@if (authUser(); as user) {
  <div class="header">
    <yt-y-button
      class="edit-btn"
      label="Edit"
      icon="fa-pencil"
      [size]="ButtonSize.ExtraSmall"
      [text]="true"
      (click)="editProfileModalService.open()"
    ></yt-y-button>
    <yt-y-button
      class="sign-out-btn"
      label="Sign Out"
      icon="fa-arrow-right-from-bracket"
      [color]="ButtonType.Danger"
      [size]="ButtonSize.ExtraSmall"
      [text]="true"
      (click)="logout()"
    ></yt-y-button>
  </div>
  <div class="profile-info">
    <p-avatar class="avatar" shape="circle" [image]="''"></p-avatar>
    <div class="user-info">
      <h3 class="user-name">{{ user.displayName }}</h3>
      <p class="user-role">Head Chef</p>
      <p>
        <i class="fa-solid fa-phone"></i>
        {{ '(324)-785-9384' }}
      </p>
      <p>
        <i class="fa-solid fa-envelope"></i>
        {{ user.email }}
      </p>
    </div>
  </div>
  <div class="preferences">
    <h5 class="preferences-title">Preferences</h5>
    <yt-y-button
      class="preference-link"
      label="Notification Settings"
      icon="fa-angle-right"
      iconPos="right"
      [text]="true"
    ></yt-y-button>
  </div>
}
